import { React, useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Header } from "../common/Header";
import { Menunav } from "../common/Menunav";
import { Sidebar } from "../common/Sidebar";
import { Link } from "react-router-dom";
import "./Scholarships.css";
import api from "../../utils/api";
import { CardActions } from "@mui/material";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  Collapse,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";

export const Userscholarship = () => {
  const navigate = useNavigate();
  const [scholarships, setScholarships] = useState([]);
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  useEffect(() => {
    api
      .get(`/scholarships/get-my-scholarships/${currentUser?.id}`)
      .then((res) => {
        console.log("scholarships>", res.data);
        setScholarships(res.data);
      })
      .catch((err) => console.log(err));
  }, []);
  const deleteScholarship = (id) => {
    api
      .delete(`/scholarships/${id}`)
      .then((res) => {
        console.log(res.data);
        window.location.reload();
      })
      .catch((err) => console.log(err));
  };

  return (
    <div>
      {/* <Header />
      <Menunav /> */}
      <div className="row ">
        {/* <div className="col-md-2 col-0">
          <Sidebar />
        </div> */}
        <div className="col-md-12 col-12">
          <div className="row mt-3">
            {/* <div className="col-6">
              <h3>Scholarships:</h3>
            </div>
            <div className="col-6">
              <Link to="/scholarship/post" className="btn-link">
                Post a Scholarship
              </Link>
            </div> */}
          </div>
          <div className="container">
            {scholarships.length > 0 ? (
              scholarships
                .sort(function (a, b) {
                  return new Date(b.updatedAt) - new Date(a.updatedAt);
                })
                .map((sch) => (
                  // <div className="row border-bottom border-dark pb-3 mb-8 mt-8">
                  //   <div className="col-lg-6 col-md-6 col-12">
                  //     <h5 className="title">
                  //       <strong>{sch?.title}</strong>
                  //     </h5>
                  //   </div>
                  //   <div className="col-lg-6 col-md-6 col-12">
                  //     <p>
                  //       Posted:{" "}
                  //       <strong className="date">
                  //         {new Date(sch?.createdAt).toDateString()}
                  //       </strong>
                  //     </p>
                  //   </div>
                  //   <div className="country">
                  //     <p>
                  //       <strong>Country: </strong> {sch?.country}
                  //     </p>
                  //   </div>
                  //   <div className="duration">
                  //     <p>
                  //       <strong>Duration: </strong> {sch?.duration}
                  //     </p>
                  //   </div>
                  //   <div className="amount">
                  //     <p>
                  //       <strong>Amount: </strong> {sch?.amount}
                  //     </p>
                  //   </div>
                  //   <div className="applydeadline">
                  //     <p>
                  //       <strong>Apply Deadline: </strong> {sch?.deadline}
                  //     </p>
                  //   </div>
                  //   <div className="scholarshipfor">
                  //     <p>
                  //       <strong>Scholarship for: </strong> {sch?.scholarshipFor}
                  //     </p>
                  //   </div>

                  //   <div className="desc">
                  //     <p>
                  //       <strong>Description</strong> {sch?.description}
                  //     </p>
                  //   </div>
                  //   {/* <div className="container-fluid p-0">
                  //   <button className="btn-projects">Web</button>
                  //   <button className="btn-projects">Web Designs</button>
                  // </div> */}
                  //   <div className="visitlink">
                  //     <h5 className="my-3">Visit Link</h5>
                  //     <a href={sch?.url}>{sch?.url}</a>
                  //   </div>
                  //   <div className=" row  mt-3 mb-3 flex-box justify-left">
                  //     <Link
                  //       to={`/scholarships/edit/${sch?._id}`}
                  //       className="btn   mr-6 btn"
                  //     >
                  //       Edit Scholarship
                  //     </Link>
                  //   </div>
                  //   <button
                  //     className="delete__scholarship__btn"
                  //     onClick={(e) => deleteScholarship(sch?._id)}
                  //   >
                  //     Delete Scholarship
                  //   </button>
                  // </div>
                  <Card sx={{ width: "100%", marginBottom: "20px" }}>
                    <CardHeader
                      avatar={
                        <Stack direction="column">
                          {currentUser?.profile ? (
                            <Avatar
                              src={currentUser?.profile}
                              alt={currentUser?.name?.at(0)?.toUpperCase()}
                            />
                          ) : (
                            <Avatar
                              sx={{ bgcolor: "colorThree.main" }}
                              aria-label="recipe"
                            >
                              {currentUser?.name?.at(0)?.toUpperCase()}
                            </Avatar>
                          )}
                        </Stack>
                      }
                      // action={
                      //   <IconButton aria-label="settings">
                      //     <MoreVertIcon />
                      //   </IconButton>
                      // }
                      title={currentUser?.name?.toUpperCase()}
                      subheader={new Date(sch?.createdAt).toDateString()}
                    />
                    {/* {hostel?.hostelImage && (
                            <CardMedia
                              component="img"
                              height="50"
                              width="50"
                              image={hostel?.hostelImage}
                              alt="Paella dish"
                            />
                          )} */}

                    <CardContent>
                      <Typography
                        sx={{
                          fontSize: "1.5rem",
                          marginBottom: "10px",
                          fontWeight: "500",
                          textTransform: "capitalize",
                        }}
                        color="fontPrimaryColor.main"
                        className="question__title"
                        // onClick={() => navigate(`/answers/${question._id}`)}
                      >
                        {sch?.title}
                      </Typography>
                      <Typography variant="body2" color="text.secondary">
                        {sch?.description}
                      </Typography>
                      {sch?.schImage && (
                        <img
                          style={{
                            margin: "20px 0",
                            marginLeft: "50%",
                            transform: "translateX(-50%)",
                          }}
                          height="auto"
                          width="60%"
                          src={sch?.schImage}
                          alt="Paella dish"
                        />
                      )}
                      <Box className="language mt-4 bg-white">
                        <Box className="tags bg-white">
                          {sch?.tags?.map((t) => (
                            <Typography className="tag-span">{t}</Typography>
                          ))}
                        </Box>
                      </Box>
                      {/* <Box className="mt-5">
                              <Typography sx={{ fontSize: "1.2rem", fontWeight: "500" }}>
                                Answers
                              </Typography>
                              <Box className="answer__container">
                                {answers.length > 0 &&
                                  answers.map((ans) => (
                                    // <Box className="ans">
                                    //   <h1>{ans.user.name}</h1>
                                    //   <p>{ans.answer}</p>
                                    // </Box>
                                    <Answer ans={ans} />
                                  ))}
                              </Box>
                           
                            </Box> */}
                      <Box
                        className="country mt-2 mb-1"
                        sx={{
                          display: "flex",
                          gap: "20px",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2" sx={{ fontWeight: "600" }}>
                          Country
                        </Typography>
                        <Typography variant="body2">{sch?.country} </Typography>
                      </Box>
                      <Box
                        className="duration mb-1"
                        sx={{
                          display: "flex",
                          gap: "20px",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2" sx={{ fontWeight: "600" }}>
                          Duration
                        </Typography>
                        <Typography>{sch?.duration} </Typography>
                      </Box>
                      <Box
                        className="duration mb-1"
                        sx={{
                          display: "flex",
                          gap: "20px",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2" sx={{ fontWeight: "600" }}>
                          Amount
                        </Typography>
                        <Typography>{sch?.amount} PKR</Typography>
                      </Box>
                      <Box
                        className="amount  mb-1"
                        sx={{
                          display: "flex",
                          gap: "20px",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2" sx={{ fontWeight: "600" }}>
                          Deadline
                        </Typography>
                        <Typography>
                          {sch?.deadline ? sch?.deadline : "null"}
                        </Typography>
                      </Box>
                      <Box
                        className="amount mb-4 mb-1"
                        sx={{
                          display: "flex",
                          gap: "20px",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2" sx={{ fontWeight: "600" }}>
                          Scholarship For
                        </Typography>
                        <Typography>
                          {sch?.scholarshipFor ? sch?.scholarshipFor : "null"}
                        </Typography>
                      </Box>
                      <Box
                        className="visitlink"
                        sx={{
                          display: "flex",
                          gap: "20px",
                          alignItems: "center",
                        }}
                      >
                        <Typography variant="body2" sx={{ fontWeight: "600" }}>
                          Visit link
                        </Typography>
                        <Typography
                          sx={{
                            color: "blue",
                            cursor: "pointer",
                            textDecoration: "underline",
                          }}
                        >
                          {sch?.url ? sch?.url : "null"}
                        </Typography>
                      </Box>
                    </CardContent>
                    <CardActions>
                      <div className="  mt-3 mb-3 flex-box justify-left ml-auto">
                        <button
                          onClick={() =>
                            navigate(`/edit-scholarship/${sch?._id}`)
                          }
                          className="asc__submit__form__button mr-2"
                        >
                          Edit Scholarship
                        </button>
                      </div>
                      <button
                        className=" asc__submit__form__button mr-2"
                        onClick={() => deleteScholarship(sch?._id)}
                      >
                        Delete Scholarship
                      </button>
                    </CardActions>
                  </Card>
                ))
            ) : (
              <h5>No Scholarship Added</h5>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};
